<template>
  <div>
    <label class="checkbox" v-for="(name, code) of authorities" :key="code">
      <input type="checkbox" v-model="selected" :value="code" />
      {{ name }}
    </label>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Authorities, authorityCode } from '@/store/common.types';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AuthoritiesInput extends Vue {
  @Prop({ required: true }) value!: authorityCode[]

  /**
   * true: 全ての権限を表示
   * false: チューターのみの権限を表示
   */
  @Prop({ default: false }) includeAll!: boolean

  private get authorities() {
    if (this.includeAll) {
      return Authorities
    }

    return _.pick(Authorities, ['senior', 'tutor'])
  }

  private get selected(): authorityCode[] {
    return this.value
  }

  private set selected(authorities: authorityCode[]) {
    this.$emit('input', authorities)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
